import ShoppingBagOutlinedIcon from '@mui/icons-material/ShoppingBagOutlined';
import OperationalPurchasesPage from './OperationalPurchasesPage';
import OperationalPurchasesSettingsPage from './OperationalPurchasesSettingsPage';
import OperationalPurchasesRoutes from './OperationalPurchasesRoutes';

const manifest = {
  id: 'operational-purchases',
  nameKey: 'extensions.operational_purchases.name',
  descriptionKey: 'extensions.operational_purchases.description',
  icon: ShoppingBagOutlinedIcon,
  route: '/operational-purchases',
  menuItem: {
    labelKey: 'operational_purchases.menu',
    basePath: '/operational-purchases',
    children: [
      { labelKey: 'operational_purchases.menu_my_purchases', path: '/operational-purchases', end: true },
      { labelKey: 'operational_purchases.menu_settings', path: '/operational-purchases/settings' },
    ],
  },
  nestedRoutes: {
    Layout: OperationalPurchasesRoutes,
    routes: [
      { index: true, Component: OperationalPurchasesPage, titleKey: 'operational_purchases.menu_my_purchases' },
      { path: 'settings', Component: OperationalPurchasesSettingsPage, titleKey: 'operational_purchases.settings_title' },
    ],
  },
  requiredExtensions: [],
  Page: OperationalPurchasesPage,
};

export default manifest;
